import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchProductTypes, createProductType, deleteProductType, updateProductType, fetchOrificeConfigByProdTypeID, fetchOrificeConfigs, createOrificeConfig, deleteOrificeConfig, updateOrificeConfig } from '../../common/jsonstore';
import { ProductType, OrificeConfig } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError, handleSuccess } from '../../services/messageApiService';


// const initialState: ProductType[] = []; //model interface
export interface IAuthentication {
  ProductType: ProductType[];
  OrificeConfig: OrificeConfig[];
  success: any;
  isProcessingComplete: boolean;
}
const initialState: IAuthentication = { ProductType: [], OrificeConfig: [], success: {}, isProcessingComplete: false };

const ProductTypeSlice = createSlice({
  name: 'ProductTypes',
  initialState,
  reducers: {

    receiveProductTypes: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        ProductType: action.payload,
        isProcessingComplete: false
      };
    },
    receiveProductType: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        ProductType: action.payload,
        isProcessingComplete: false
      };
    },

    receiveOrificeConfig: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        OrificeConfig: action.payload,
        isProcessingComplete: false
      };
    },

    success: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        success: action.payload,
        isProcessingComplete: true
      };
    }
  }
});

// export const { toggleProductType } = ProductTypeSlice.actions;

export const loadProductTypes = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const ProductTypes = await fetchProductTypes().then((res: any) => {
      dispatch(ProductTypeSlice.actions.receiveProductTypes(res))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Product type not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addProductType = (newProductType: ProductType): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await createProductType(newProductType).then((res) => {
      dispatch(ProductTypeSlice.actions.receiveProductType([...getState().ProductTypes.ProductType, res]));
      dispatch(ProductTypeSlice.actions.success({ 'sts': true, data: 'Product Type Added Succefully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Product Type Not Added';
        dispatch(ProductTypeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyProductType = (newProductType: ProductType, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const resppp = await updateProductType(newProductType, id).then((res: any) => {
      const updatedProductTypes = getState().ProductTypes.ProductType.map(el => (el.id === id ? res : el))
      dispatch(ProductTypeSlice.actions.receiveProductTypes(updatedProductTypes));
      dispatch(ProductTypeSlice.actions.success({ 'sts': true, data: 'Product Type Updated Succefully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Product Type not Updated';
        dispatch(ProductTypeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeProductType = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteProductType(id).then((res) => {
      const updatedProductTypes = getState().ProductTypes.ProductType.filter((item) => item.id !== id);
      dispatch(ProductTypeSlice.actions.receiveProductTypes(updatedProductTypes));
      dispatch(ProductTypeSlice.actions.success({ 'sts': true, data: 'Product Type Deleted Successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Product Type Not Deleted';
        dispatch(ProductTypeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  dispatch(ProductTypeSlice.actions.success(data));
}


export const loadOrificeConfigByProdTypeID = (id: number): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const data: any = await fetchOrificeConfigByProdTypeID(id).then((res: any) => {
      dispatch(ProductTypeSlice.actions.receiveOrificeConfig(res?.data))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'data not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const loadOrificeConfigs = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const OrificeConfigs = await fetchOrificeConfigs().then((res: any) => {
      dispatch(ProductTypeSlice.actions.receiveOrificeConfig(res))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Something Happened';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addOrificeConfig = (newOrificeConfig: OrificeConfig): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await createOrificeConfig(newOrificeConfig).then((res) => {
      dispatch(ProductTypeSlice.actions.receiveOrificeConfig([...getState().ProductTypes.OrificeConfig, res]));
      dispatch(ProductTypeSlice.actions.success({ 'sts': true, data: 'Orifice Config Added Succefully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Orifice Config Not Added';
        dispatch(ProductTypeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyOrificeConfig = (newOrificeConfig: OrificeConfig, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await updateOrificeConfig(newOrificeConfig, id).then((res: any) => {
      const updatedOrificeConfigs = getState().ProductTypes.OrificeConfig.map(el => (el.id === id ? res : el))
      dispatch(ProductTypeSlice.actions.receiveOrificeConfig(updatedOrificeConfigs));
      handleSuccess('updated Successfully ')
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Not updated';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeOrificeConfig = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteOrificeConfig(id).then((res) => {
      const updatedOrificeConfigs = getState().ProductTypes.OrificeConfig.filter((item) => item.id !== id);
      dispatch(ProductTypeSlice.actions.receiveOrificeConfig(updatedOrificeConfigs));
      dispatch(ProductTypeSlice.actions.success({ 'sts': true, data: 'Orifice Config Deleted Succefully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Orifice Config Not Deleted';
        dispatch(ProductTypeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export default ProductTypeSlice.reducer;
